import { render, staticRenderFns } from "./NotasNivel1DadosAgrupado.vue?vue&type=template&id=65c309b3&scoped=true"
import script from "./NotasNivel1DadosAgrupado.vue?vue&type=script&lang=js"
export * from "./NotasNivel1DadosAgrupado.vue?vue&type=script&lang=js"
import style0 from "./NotasNivel1DadosAgrupado.vue?vue&type=style&index=0&id=65c309b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c309b3",
  null
  
)

export default component.exports